import { Injectable } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { AssigneePickerModalComponent } from "./assignee-picker.modal.component";
import { ApiService } from "source/app/configuration/services/api.service";
import { AssignmentDefinition } from "../../assignment.interface";
import { RideOpsUiService } from "source/app/configuration/services/rideops-ui.service";

@Injectable()
export class AssigneePickerModalService {
	constructor(
		private modalcontroller: ModalController,
		private apiService: ApiService,
		private rideOpsUi: RideOpsUiService,
	) {}

	create = async (assignees: { id: string; name: string }[], definition: AssignmentDefinition) => {
		const possibleAssignees = await this.apiService.assignees(definition?.id);

		return this.modalcontroller.create({
			id: AssigneePickerModalComponent.modalId,
			component: AssigneePickerModalComponent,
			cssClass: this.rideOpsUi.isV2Active()
				? "assignee-picker-modal assignee-picker-modal-v2"
				: "assignee-picker-modal",
			componentProps: {
				possibleAssignees,
				assignees: assignees,
				singleSelect: definition?.assigneeSelectionMode === "Single" || false,
			},
		});
	};
}
